export const MAX_PROJECT_NAME_LENGTH = 35

/**
 * 각 씬의 스크립트에 입력 가능한 최대 바이트 수
 *
 * 20000 바이트
 */
export const MAX_SCENE_SCRIPT_BYTES = 20000

/**
 * 오디오 스크립트에 입력 가능한 최대 바이트 수
 *
 * 100mb (unit: byte)
 */
export const MAX_AUDIO_SCRIPT_BYTES = 1024 * 1024 * 100

/**
 * 오디오 스크립트에 입력 가능한 최대 시간
 *
 * 20분 (unit: ms)
 */
export const MAX_AUDIO_SCRIPT_DURATION = 1000 * 60 * 20

/**
 * 업로드 애셋 파일 최대 크기
 * 
 * 1GB (unit: byte)
 * 
 * 기존 값 그대로 상수화 만 했음
 */
export const MAX_ASSET_SIZE = 1024 * 1024 * 1024;


/**
 * 업로드 하는 애샛의 용도/종류
 */
export const ASSET_UPLOAD_TYPE = {
  AUDIO_SCRIPT: 'AUDIO_SCRIPT',
} as const

export type AssetUploadType =
  (typeof ASSET_UPLOAD_TYPE)[keyof typeof ASSET_UPLOAD_TYPE]
